import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { ApxOverlayDirective } from './overlay.directive';
import { ApxOverlayCloseOnClickAwayDirective } from './overlay-close.directive';

@NgModule({
    imports: [CommonModule, OverlayModule, ApxOverlayDirective, ApxOverlayCloseOnClickAwayDirective],
    exports: [ApxOverlayDirective, ApxOverlayCloseOnClickAwayDirective]
})
export class ApxOverlayModule {}
